import  { useState } from "react";
import { Button, Radio } from "antd";
import Degree from "@/components/coordinate/Degree";
import LatLong from "@/components/coordinate/LatLong";

function ComplexSearch({ options, findCity, setSearchState, searchState }) {
  const [btnHandeler, setBtnHandler] = useState();
  const [coordinateArray, setCoordinateArray] = useState(null);
  const [serachType, setSearchType] = useState(1);
  const serachBox = (x) => {
    if (x === 1) {
      return (
        <LatLong
          searchState={searchState}
          setSearchState={setSearchState}
          setCoordinateArray={setCoordinateArray}
          setBtnHandler={setBtnHandler}
        />
      );
    } else if (x === 2) {
      return (
        <Degree
          searchState={searchState}
          setSearchState={setSearchState}
          setCoordinateArray={setCoordinateArray}
          setBtnHandler={setBtnHandler}
        />
      );
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {" "}
      {
        serachBox(serachType)
      }
      <section
        className="flex flex-row gap-2 px-1 items-center jus max-lg:!rounded-xl inner-box-hover w-[60vw] max-w-[400px] relative h-[34px] 
    max-lg:flex-col max-lg:gap-3 max-lg:h-fit "
      >
        <p>جستجو بر اساس:</p>
        <Radio.Group
          className="flex flex-row justify-center items-center"
          defaultValue={1}
          onChange={(e) => {
            setCoordinateArray(null)
            setSearchType(e.target.value);
          }}
          value={serachType}
        >
          <Radio className="flex flex-row justify-center items-center" value={1}>Lat , Long</Radio>
          <Radio className="flex flex-row justify-center items-center" value={2}>Degree</Radio>
          <Radio className="flex flex-row justify-center items-center" disabled value={3}>UTM</Radio>
        </Radio.Group>
      </section>
      <Button
        onClick={() => {
          findCity(coordinateArray)
          setBtnHandler("")
        }}
        hidden={serachType === 1 ? !btnHandeler?.includes(",") : (!coordinateArray)}
        className=" button-green text-white text-base bottom-0 left-0 w-[92px] h-[34px] absolute max-lg:w-10/12 max-lg:left-0"
      >
        تایید
      </Button>
    </div>
  );
}

export default ComplexSearch;
